import {
  Box,
  Button,
  Drawer,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { Card } from "../../ui/Card";
import toast from "react-hot-toast";
import dayjs, { Dayjs } from "dayjs";
import { OrderRowType } from "./OrderData";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { scheduleOrder } from "./orderApi";

const MultipleOrderScheduleDrawer = ({
  ids,
  data,
  open,
  handleClose,
  setSyncOrder, // optional callback
}: {
  ids: GridRowSelectionModel;
  data: OrderRowType[];
  open: boolean;
  handleClose: () => void;
  setSyncOrder?: () => void;
}) => {
  const [pickupDate, setPickupDate] = useState<Dayjs | null>(dayjs());
  const [loading, setLoading] = useState(false);

  const formatDateTime = (date: Date) => {
    // Format as YYYY-MM-DD HH:mm:ss
    return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  };

  const handleSchedulePickup = async () => {
    if (!pickupDate) {
      toast.error("Please select a pickup date.");
      return;
    }
    setLoading(true);
    try {
      const payload = ids.map((id) => ({
        id: typeof id === "string" ? parseInt(id) : id,
        pickup_date: formatDateTime(pickupDate.toDate()),
      }));
      const data:any = await scheduleOrder(payload);
      if (data?.data?.data?.[0]?.error === false) {
        toast.success("Order Scheduled successfully!");
        handleClose();
        if (setSyncOrder) setSyncOrder();
      } else {
        toast.error(data?.data?.data?.[0]?.message || "Failed to schedule pickup.");
      }
    } catch (err) {
      toast.error("Failed to schedule pickup.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <div className="multiple-order-assign">
        <Box sx={{ padding: "10px 30px" }}>
          <Box sx={{ fontWeight: 600, fontSize: 22, mb: 3 }}>
            Schedule Pickup Your Order
          </Box>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "40px",
              flexWrap: "wrap",
              rowGap: "20px",
              marginTop: "20px",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Pickup Date"
                value={pickupDate}
                onChange={setPickupDate}
                minDate={dayjs()}
                slotProps={{
                  textField: { sx: { width: "40%", marginRight: 2 } },
                }}
              />
            </LocalizationProvider>
            <Button
              onClick={handleSchedulePickup}
              variant="contained"
              disabled={!pickupDate || loading}
              sx={{ marginLeft: "10px" }}
            >
              {loading ? "Scheduling..." : "Schedule Pickup"}
            </Button>
          </Stack>
          <TableContainer component={Card}>
            <Table sx={{ minWidth: 650 }} aria-label="orders table">
              <TableHead>
                <TableRow>
                  <TableCell>id</TableCell>
                  <TableCell>Vendor</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>Receiver</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row?.id}</TableCell>
                    <TableCell>{row?.vendor}</TableCell>
                    <TableCell>{row?.description}</TableCell>
                    <TableCell>
                      {row?.from}-{row?.to}
                    </TableCell>
                    <TableCell>{row?.receiver}</TableCell>
                    <TableCell>{row?.amount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </Drawer>
  );
};

export default MultipleOrderScheduleDrawer;
